import type { TypedDocumentNode } from '@apollo/client';

import { gql } from '@apollo/client';

export interface GetAppSettingsQuery {
  appSettings: {
    documentPathRegex: string;
    localEndpoints?: boolean | null;
    localDatabase?: boolean | null;
    aiAssistEditChatModels: string[];
    defaultAiAssistEditChatModel: string;
  };
}

export type GetAppSettingsQueryVariables = Record<string, never>;

export const GET_APP_SETTINGS: TypedDocumentNode<
  GetAppSettingsQuery,
  GetAppSettingsQueryVariables
> = gql`
  query GetAppSettings {
    appSettings {
      documentPathRegex
      localEndpoints
      localDatabase
      aiAssistEditChatModels
      defaultAiAssistEditChatModel
    }
  }
`;
